import { IOnboardingChecklistState } from "./onboardingChecklist.types";
import { defaultOnboardingChecklistState } from "./defaultState";
import {
  FETCH_ONBOARDING_CHECKLIST_PROGRESS,
  FETCH_ONBOARDING_CHECKLIST_SUCCESS,
  FETCH_ONBOARDING_CHECKLIST_FAILED,
} from "./onboardingChecklistActions";

export const onboardingChecklistReducer = (
  state: IOnboardingChecklistState = defaultOnboardingChecklistState,
  action: { type: string; payload?: any },
): IOnboardingChecklistState => {
  switch (action.type) {
    case FETCH_ONBOARDING_CHECKLIST_PROGRESS:
      return { ...state, loading: true, error: null };
    case FETCH_ONBOARDING_CHECKLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case FETCH_ONBOARDING_CHECKLIST_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
};
